/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Section_Sales_ConsultantInputs */

const en_clients_section_sales_consultant = /** @type {(inputs: Clients_Section_Sales_ConsultantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sales Consultant`)
};

const pt_br2_clients_section_sales_consultant = /** @type {(inputs: Clients_Section_Sales_ConsultantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consultor comercial`)
};

/**
* | output |
* | --- |
* | "Sales Consultant" |
*
* @param {Clients_Section_Sales_ConsultantInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_section_sales_consultant = /** @type {((inputs?: Clients_Section_Sales_ConsultantInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Section_Sales_ConsultantInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_section_sales_consultant(inputs)
	return pt_br2_clients_section_sales_consultant(inputs)
});